import React, { useState, useEffect } from 'react'
import Icon from 'srcReact/components/icons/Icon'
import { convertTo24HourFormat } from 'srcReact/helpers/datetimeHelper'
import { getCurrentLanguageFromCookie } from 'srcReact/helpers/utils'
import Dropdown1 from '../Dropdown1'
import styles from './styles.module.scss'

export default function TimePicker({
  isMobile,
  time,
  size,
  className,
  setRef,
  handleTimeChange,
  minutesDuration = 15,
  startingTime = null,
  disabled = false,
  menuPortalTarget = false
}) {
  const [selectedTime, setSelectedTime] = useState(null)
  const [times, setTimes] = useState([])
  const hours = ['12', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11']
  let minutes = ['00', '15', '30', '45']
  const tt = ['AM', 'PM']

  useEffect(() => {
    if (time) {
      const timeObj = times.find((t) => t.value === time)
      setSelectedTime(timeObj)
    }
  }, [time])

  if (minutesDuration === 30) {
    minutes = ['00', '30']
  } else if (minutesDuration === 60) {
    minutes = ['00']
  }

  const getTimes = () => {
    const arr = []
    let startHr = null
    let startMin = null
    if (startingTime && startingTime.length > 0) {
      startHr = parseInt(startingTime.split(':')[0])
      startMin = parseInt(startingTime.split(':')[1])
    }
    for (let t = 0; t < tt.length; t++) {
      for (let h = 0; h < hours.length; h++) {
        for (let m = 0; m < minutes.length; m++) {
          let time = `${hours[h]}:${minutes[m]} ${tt[t]}`
          let format24 = convertTo24HourFormat(time)
          const format24Arr = format24.split(':')
          let isValid = isGreaterThanStartTime(startHr, startMin, format24)
          if (isValid) {
            if (getCurrentLanguageFromCookie() === 'fr') {
              arr.push({ label: `${format24Arr[0]}:${format24Arr[1]}`, value: format24 })
            } else {
              arr.push({ label: time, value: format24 })
            }
          }
        }
      }
    }
    return arr
  }

  useEffect(() => {
    const arr = getTimes()
    setTimes([...arr])
  }, [startingTime])

  useEffect(() => {
    const arr = getTimes()
    setTimes([...arr])
  }, [])

  useEffect(() => {
    if (time && times.length > 0) {
      const timeObj = times.find((t) => t.value === time)
      setSelectedTime(timeObj)
    }
  }, [times])

  const handleChange = (selected) => {
    setSelectedTime(selected)
    handleTimeChange(selected)
  }

  const isGreaterThanStartTime = (startHr, startMin, selectedTime) => {
    if (startHr >= 0 && startMin >= 0) {
      const format24Arr = selectedTime.split(':')
      const selectedHr = parseInt(format24Arr[0])
      const selectedMin = parseInt(format24Arr[1])
      if (startHr === null || selectedHr > startHr || (selectedHr === startHr && selectedMin > startMin)) {
        return true
      } else {
        return false
      }
    }
    return true
  }

  return (
    <Dropdown1
      isDisabled={disabled}
      setRef={setRef}
      size={size}
      value={selectedTime}
      options={times}
      className={`${styles.timePicker} ${className}`}
      placeholder='hh:mm'
      // className={styles.dropdownSelectedItem}
      onChange={handleChange}
      isSearchable={false}
      menuPortalTarget={menuPortalTarget}
    />
  )
}
